export const MAX_WORD_LENGTH = 5
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
export const X_URL =
  'https://x.com/search?q=%23%D0%B1%D1%83%D0%BE%D1%80%D0%B4%D1%83%D0%BB%D1%83&f=live'
